<template>
  <modal
    title="Share pay link"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="w-full text-primary-yellow py-2">
      View Bill
    </div>

    <div class="individual-contaoner">
      <label class="label">Pay Link</label>
      <div class="flex items-center input-field px-2">
        <input
          v-model="paymentUrl"
          :disabled="true"
          placeholder="--Autoloaded--"
          class="w-full py-2 pl-3 bg-transparent"
        />
        <img
          @click="copyPayLink"
          src="@/assets/images/icons/copy.svg"
          class="cursor-pointer"
        />
      </div>
    </div>

    <div class="individual-contaoner">
      <label class="label">Customer’s Email </label>
      <input
        v-model="companyEmail"
        :disabled="true"
        placeholder="--Autoloaded--"
        class="w-full py-2 pl-3 input-field cursor-not-allowed"
      />
    </div>

    <div class="individual-contaoner">
      <label class="label">Payment Amount (NGN) </label>
      <input
        v-model="amount"
        :disabled="true"
        placeholder="--Autoloaded--"
        class="w-full py-2 pl-3 input-field"
      />
    </div>

    <!-- <div class="individual-contaoner">
      <label class="label">Note</label>
      <textarea
        placeholder="Text Area"
        v-model="note"
        @input="checkTextlength"
        class="input-field w-full h-32 resize-none p-3"
      ></textarea>
      <span class="w-full text-right block">{{ note.length }}/300</span>
    </div> -->

    <div class="actions flex items-center justify-end cursor-pointer mt-20">
      <div>
        <primary-button
          class="shadow-md"
          buttonText="Submit"
          :loading="loading"
          @click="shareWaiting"
        />
      </div>
      <div>
        <p @click="closeModal()" class="pl-3">Cancel</p>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    paymentParams: {
      type: Object,
    },
   transactionId :{
    type: String,
   },
  },

  data() {
    return {
      paymentUrl: "",
      amount: "",
      companyEmail: "",
      shippingId : "",
      note: "",
    };
  },

  mounted() {
    this.companyEmail = this.paymentParams.email;
    this.amount = this.paymentParams.payAmount;
    this.shippingId = this.paymentParams.shippingId
    
    if(this.shippingId.length > 0){
      this.getPaymentLink()
    }
    
  },
  watch: {
    paymentParams() {
      this.companyEmail = this.paymentParams.email;
      this.amount = this.paymentParams.payAmount;
      this.shippingId = this.paymentParams.shippingId
    },
    shippingId(val){
      this.paymentUrl = ""
      if(val.length > 0){
        this.getPaymentLink()
      }
      
    },
    showModal(val){
      console.log("val",  this.paymentParams, val)
    }
  },
  computed: {
    payload() {
      return {
        status: "paid",
        userId: "",
        totalValue: 3000,
        paymentStatus: "paid",
        breakDown: {
          vat: 50,
          insuranceFee: 400,
          handlingCharges: 90,
          note: this.note,
          amount_paid: this.amount,
          payment_type: this.paymentType,
          payment_date: "",
          orgId: "",
        },
        productId: "",
      };
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async getPaymentLink() {
      try {
        const response = await this.$_newGetPaymentLink(this.shippingId);
        this.paymentUrl = response.data.paymentUrl
      } catch (error) {
        this.handleError(error);
      }
    },
    
    async shareWaiting(){
      this.loading = true
      try {
        await this.$_sharePayLink(this.shippingId);
        this.closeModal()
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false
    },
    copyPayLink() {
      navigator.clipboard.writeText(this.paymentUrl);
      this.generateToast("copied successfully", "success");
    },
    checkTextlength(event) {
      let value = event.target.value;
      if (this.note.length > 300) {
        this.note = value.substring(0, 300);
        return;
      }
      this.note = value;
    },
  },
};
</script>

<style scoped lang="scss">
.label {
  @apply w-full pb-0;
  font-size: 13px;
}
.individual-contaoner {
  @apply w-full p-2 my-0;
}
.filter-search {
  border-radius: 4px;
  @apply py-2;
}
.input-field {
  @apply bg-gray-200;
}
</style>
